export const StudentList = [
  {
    id: 1,
    firstName: 'افشین',
    lastName: 'زنگنه',
    imageSrc: 'https://randomuser.me/api/portraits/men/51.jpg',
    status: "تحویل داده شده"
  },
  {
    id: 2,
    firstName: 'مرتضی',
    lastName: 'شهرابی فراهانی',
    imageSrc: 'https://randomuser.me/api/portraits/men/31.jpg',
    status: "مشاهده شده"
  },
  {
    id: 3,
    firstName: 'محمد مهدی',
    lastName: 'جاوید',
    imageSrc: 'https://randomuser.me/api/portraits/men/43.jpg',
    status: "تحویل داده نشده"

  },
  {
    id: 4,
    firstName: 'غزل',
    lastName: 'بخشنده',
    imageSrc: 'https://randomuser.me/api/portraits/women/65.jpg',
    status: "تحویل داده شده"

  },
  {
    id: 5,
    firstName: 'بیان',
    lastName: 'دیوانی آذر',
    imageSrc: 'https://randomuser.me/api/portraits/women/13.jpg',
    status: "مشاهده شده"

  },
  {
    id: 6,
    firstName: 'دانیال',
    lastName: 'بازمانده',
    imageSrc: 'https://randomuser.me/api/portraits/men/3.jpg',
    status: "تحویل داده شده"

  },
  {
    id: 7,
    firstName: 'حانیه',
    lastName: 'جعفری',
    imageSrc: 'https://randomuser.me/api/portraits/women/81.jpg',
    status: "تحویل داده نشده"

  },
  {
    id: 8,
    firstName: 'سید عماد',
    lastName: 'موسوی',
    imageSrc: 'https://randomuser.me/api/portraits/men/44.jpg',
    status: "مشاهده شده"

  },
  {
    id: 9,
    firstName: 'باوان',
    lastName: 'دیوانی آذر',
    imageSrc: 'https://randomuser.me/api/portraits/women/84.jpg',
    status: "تحویل داده نشده"

  },
  {
    id: 10,
    firstName: 'علی',
    lastName: 'صداقی',
    imageSrc: 'https://randomuser.me/api/portraits/men/42.jpg',
    status: "تحویل داده شده"

  },
  {
    id: 11,
    firstName: 'مصطفی',
    lastName: 'حسینی',
    imageSrc: 'https://randomuser.me/api/portraits/men/76.jpg',
    status: "مشاهده شده"

  },
  {
    id: 12,
    firstName: 'امیرمحمود',
    lastName: 'رضایی',
    imageSrc: 'https://randomuser.me/api/portraits/men/18.jpg',
    status: "مشاهده شده"

  },
];
